<div class="container">
  <br />
  <br />
  <br />

  <div class="top-bar">
    <h2>
      Search results for
      <span class="q">{{ query }}</span>
    </h2>
    <span
      [ngClass]="{ active: showing === 'ideas' }"
      (click)="showing = 'ideas'">
      Projects
      <span class="count">({{ ideas?.length || 0 }})</span>
    </span>
    <span
      [ngClass]="{ active: showing === 'topics' }"
      (click)="showing = 'topics'">
      Topics
      <span class="count">({{ sessions?.length || 0 }})</span>
    </span>
    <span
      [ngClass]="{ active: showing === 'people' }"
      (click)="showing = 'people'">
      People
      <span class="count">({{ people?.length || 0 }})</span>
    </span>
  </div>

  <br />
  <br />

  <div class="ideas results" *ngIf="showing === 'ideas'">
    <div class="view-control">
      <img
        alt
        src="/assets/images/view-expanded.svg"
        title="Expanded Project Cards"
        [ngClass]="{ active: !compact }"
        (click)="compact = false" />
      <div class="divider"></div>
      <img
        alt
        src="/assets/images/view-small.svg"
        title="Compact Project Cards"
        [ngClass]="{ active: compact }"
        (click)="compact = true" />
    </div>
    <div class="empty" *ngIf="!ideas || ideas.length === 0">
      <img alt src="/assets/images/empty-row.svg" />
      <h3>No project could be found</h3>
    </div>
    <app-idea-card
      [idea]="idea"
      *ngFor="let idea of ideas"
      [small]="compact"
      [session]="idea.session"
      [showTopic]="true"
      (ideaAction)="openIdea(idea, idea.session)"></app-idea-card>
  </div>

  <div class="topics results" *ngIf="showing === 'topics'">
    <div class="empty" *ngIf="!sessions || sessions.length === 0">
      <img alt src="/assets/images/empty-row.svg" />
      <h3>No topics could be found</h3>
    </div>
    <div class="session-cards-holder">
      <session-card
        class="col-lg-6 col-12"
        *ngFor="let session of sessions"
        [session]="session"></session-card>
    </div>
  </div>

  <div class="people results" *ngIf="showing === 'people'">
    <div class="empty" *ngIf="!people || people.length === 0">
      <img alt src="/assets/images/empty-row.svg" />
      <h3>No matching people found</h3>
    </div>
    <a
      class="user-info"
      *ngFor="let user of people"
      href="/profile/{{ user._id }}"
      target="_blank">
      <div class="info">
        <profile-picture [user]="user" size="medium"></profile-picture>
        <name-tag [user]="user" size="medium"></name-tag>
      </div>
      <div class="actions">
        <a
          class="btn btn-primary"
          href="/profile/{{ user._id }}"
          target="_blank">
          Profile
        </a>
        <button class="btn btn-primary" (click)="directMsg(user, $event)">
          Send a Message
        </button>
      </div>
    </a>
  </div>
</div>
